/**
 * Drops a trailing unit suffix (e.g. "11 m", "26.4m²", "1e3 kg") from a typed
 * value, leaving just the numeric prefix. Units are appended at display time,
 * so persisting them would double up.
 *
 * The matcher captures the leading numeric prefix only — checking for a
 * remainder separately. An earlier version of this helper anchored
 * `\s*\S.*$` after the capture, which let the regex backtrack into the
 * numeric group on bare numbers (e.g. "11" → "1", "26.4" → "26"). See
 * WHA-3145.
 */
const NUMERIC_PREFIX_RE = /^([-+]?\d+(?:[.,]\d+)?(?:[eE][-+]?\d+)?)/;

export function stripTrailingUnit(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return trimmed;
  const m = NUMERIC_PREFIX_RE.exec(trimmed);
  if (!m) return trimmed;
  const numeric = m[1];
  const rest = trimmed.slice(numeric.length);
  return rest.length === 0 ? trimmed : numeric;
}
